import { render, staticRenderFns } from "./SimpleCardList.vue?vue&type=template&id=d4dacca4&scoped=true"
import script from "./SimpleCardList.vue?vue&type=script&lang=js"
export * from "./SimpleCardList.vue?vue&type=script&lang=js"
import style0 from "./SimpleCardList.vue?vue&type=style&index=0&id=d4dacca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dacca4",
  null
  
)

export default component.exports